<template>
  <main class="access-recovery" role="alert" aria-live="polite">
    <section>
      <h1>页面暂时无法打开</h1>
      <p>权限或页面加载未完成，请检查网络后重试。</p>
      <p v-if="hasSession">登录状态仍然保留，无需重复提交刚才的业务操作。</p>
      <p v-else>请重试打开登录页面。</p>
      <el-button type="primary" :loading="retrying" @click="retry">重新加载</el-button>
      <el-button :disabled="retrying" @click="login">重新登录</el-button>
      <el-button @click="exportClientDiagnostics">导出故障记录</el-button>
      <p v-if="failed">暂时仍无法连接，请稍后再试。</p>
    </section>
  </main>
</template>

<script>
import { resetRouter } from '@/router'
import { safeReturnPath } from '@/router/authenticated-navigation'
import { getToken } from '@/utils/auth'
import { exportClientDiagnostics } from '@/utils/client-diagnostics'

export default {
  name: 'AccessRecovery',
  data () { return { retrying: false, failed: false, hasSession: Boolean(getToken()) } },
  methods: {
    exportClientDiagnostics,
    async retry () {
      if (this.retrying) return
      this.retrying = true
      this.failed = false
      try {
        if (!getToken()) {
          await this.$router.replace('/login')
          return
        }
        await this.$store.dispatch('access/refresh')
        this.$store.commit('permission/RESET_ROUTES')
        resetRouter()
        await this.$router.replace(safeReturnPath(this.$route.query.redirect))
      } catch (error) {
        // addRoutes can cause an intentional router redirect; the guard owns
        // recovery if route installation or component loading actually fails.
        this.failed = !error || !error._isRouter
      } finally {
        this.retrying = false
      }
    },
    async login () {
      await this.$store.dispatch('ForceLogout')
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.access-recovery { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f5f7fa; color: #303133; }
.access-recovery section { max-width: 520px; margin: 24px; padding: 32px; background: white; border-radius: 12px; }
.access-recovery h1 { font-size: 24px; margin-bottom: 20px; }
.access-recovery p { line-height: 1.7; margin-bottom: 20px; color: #606266; }
</style>



// WEBPACK FOOTER //
// src/views/access-recovery/index.vue